import { render, staticRenderFns } from "./application-value-DigitalCollPlatform.vue?vue&type=template&id=58a83b7a&scoped=true"
import script from "./application-value-DigitalCollPlatform.vue?vue&type=script&lang=js"
export * from "./application-value-DigitalCollPlatform.vue?vue&type=script&lang=js"
import style0 from "./application-value-DigitalCollPlatform.vue?vue&type=style&index=0&id=58a83b7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a83b7a",
  null
  
)

export default component.exports